import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";
import { GetCollaborationStoresFilter } from "../../models/collaborationStores.model";
import { useQueryClient } from "react-query";
import ChipCmp from "../chip/chipCmp";
import DropdownCmp2 from "../dropdown/DropdownCmp2";

interface Props {
  setFilterObject: (filterObj: GetCollaborationStoresFilter) => void;
  filterObject: GetCollaborationStoresFilter;
  setCurrentPaginationInfo: (page: any) => void;
}
const personTypeOptions = [
  { title: "حقیقی", id: 1, enumData: "individual" },
  { title: "حقوقی", id: 2, enumData: "company" },
];
const CollaborationStoresListFilters = ({
  filterObject,
  setFilterObject,
  setCurrentPaginationInfo,
}: Props) => {
  const [formData, setFormData] = useState<GetCollaborationStoresFilter>(
    filterObject || {},
  );
  const [personTypeValue, setPersonTypeValue] = useState<any>();
  const [personTypeToChip, setPersonTypeToChip] = useState("");

  const queryClient = useQueryClient();

  const handleChangeForm = (event: any) => {
    setFormData({
      ...formData!,
      [event.target.id]: event.target.value,
    });
  };

  const deleteChip = () => {
    setFormData({
      companyName: "",
      businessOwnerName: "",
      personType: "",
    });

    setPersonTypeValue(undefined);
    setPersonTypeToChip("");
    setFilterObject({});
  };
  const handleFormSubmit = () => {
    setCurrentPaginationInfo({
      pageNumber: 1,
      pageSize: 10,
    });

    setFilterObject({
      ...formData,
      personType: personTypeValue,
    });
  };

  const setChildcompanyName = () => {
    setFormData({ ...formData, companyName: "" });
  };
  const setChildbusinessOwnerName = () => {
    setFormData({ ...formData, businessOwnerName: "" });
  };
  const setChildisPersonType = () => {
    setFormData({ ...formData, personType: undefined });
    setPersonTypeToChip("");
    setPersonTypeValue(undefined);
  };
  const handleSelectedPersonTypeDrop = (e: any, value: any) => {
    setPersonTypeValue(e.target.value);
    let obj = personTypeOptions.filter(
      (item) => item.enumData === e.target.value,
    );
    setPersonTypeToChip(obj[0].title);
  };
  useEffect(() => {
    if (filterObject) {
      setFormData(filterObject);
      setPersonTypeValue(filterObject.personType);

      const obj = personTypeOptions.find(
        (item) => item.enumData === filterObject.personType,
      );
      setPersonTypeToChip(obj?.title || "");
    }
  }, [filterObject]);
  return (
    <div>
      <Box>
        <div className="row">
          <div
            className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"نام کامل شرکت/فروشگاه"}
              label={"نام کامل شرکت/فروشگاه"}
              required={false}
              value={formData?.companyName}
              onChange={(e: any) => handleChangeForm(e)}
              name="companyName"
              id="companyName"
            />
          </div>
          <div
            className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"نام مدیرعامل/مالک فروشگاه"}
              label={"نام مدیرعامل/مالک فروشگاه"}
              required={false}
              value={formData?.businessOwnerName}
              onChange={(e: any) => handleChangeForm(e)}
              name="businessOwnerName"
              id="businessOwnerName"
            />
          </div>
          <div
            className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 dropdownCmp2-container"
            style={{ marginTop: "1vh" }}
          >
            <DropdownCmp2
              style={{
                paddingRight: "0 !important",
              }}
              onChange={handleSelectedPersonTypeDrop}
              value={personTypeValue}
              label={"نوع شخص"}
              options={personTypeOptions}
              name="personType"
              id="personType"
              darkTheme={true}
              // defaultValue={dafaultDropdownValue}
            />
          </div>
          <div
            className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter"
            style={{ marginTop: "1vh" }}
          >
            <Button
              fullWidth
              variant="contained"
              // type="submit"
              className="btnForm SuccessDefault  "
              onClick={handleFormSubmit}
            >
              اعمال فیلتر
            </Button>
          </div>
        </div>
        {(formData?.companyName ||
          formData?.businessOwnerName ||
          personTypeValue) && (
          <div
            style={{ display: "flex", alignItems: "center" }}
            className="row tableCMP"
          >
            <Button
              onClick={deleteChip}
              style={{
                justifyContent: "right",
                minWidth: "25px",
                marginRight: "-1vh",
                marginTop: "1vh",
              }}
            >
              <img
                style={{ height: "24px", width: "24px" }}
                src="images/RemoveAllFilters.svg"
                alt=""
              />
            </Button>
            <ChipCmp
              item={formData?.companyName}
              enamValue={formData?.companyName}
              index={formData?.companyName?.length}
              setChildValue={setChildcompanyName}
            />
            <ChipCmp
              item={formData?.businessOwnerName}
              enamValue={formData?.businessOwnerName}
              index={formData?.businessOwnerName?.length}
              setChildValue={setChildbusinessOwnerName}
            />
            <ChipCmp
              item={personTypeToChip}
              enamValue={personTypeToChip}
              setChildValue={setChildisPersonType}
            />
          </div>
        )}
      </Box>
    </div>
  );
};

export default CollaborationStoresListFilters;
